import React from 'react';

import { LENDER_CITY } from '../../constants';
import LenderAddressTextField from './LenderAddressTextField.interstate';

const LenderCityField = () => (
    <LenderAddressTextField id="LenderCityField" dataTestId="lender-city" label={LENDER_CITY} name="lender-city" field="city" />
);

export default LenderCityField;
